import { useState, useMemo, useEffect } from 'react';
import cn from "classnames";
import { CountriesSelect, ICountriesSelectOption } from "@datassential/platform-ui-lib";
import { FCX, ID } from '@models';
import { IconLock } from '@svg';
import { useCountrySwitch } from '@hooks/useCountrySwitch';
import { useUserContext } from '@core/UserContext';
import './Countries.scss';

const Countries: FCX = () => {
    const { countries: rawCountries } = useUserContext();
    const { switchCountry } = useCountrySwitch();
    const [countries, setCountries] = useState(rawCountries);

    useEffect(() => {
        setCountries(rawCountries);
    }, [rawCountries]);

    const currentCountry = countries.find(c => c.selected);

    const handleSwitchCountry = (id: ID) => {
        if (id !== currentCountry?.id) {
            setCountries(countries.map(c => ({
                ...c,
                selected: c.id === id,
            })));
        }
        switchCountry(id);
    };

    const countriesOptionsPlatform = useMemo(
        (): ICountriesSelectOption[] => countries.map(c => ({
            id: c.id ?? 0,
            shortName: c.alpha3Code ?? '',
            name: c.fullName ?? '',
            className: cn(
                'CountriesSelect__option',
                !c.enabled && 'disabled',
            ),
            children: c.enabled ? null : (
                <div className="CountriesSelect__lock">
                    <IconLock className="CountriesSelect__lock-icon"/>
                </div>
            ),
        })),
        [countries]
    )

    return (
        <>
            {currentCountry && (
                <CountriesSelect
                    options={countriesOptionsPlatform}
                    value={currentCountry.id}
                    setValue={(id) => handleSwitchCountry(id ?? 0)}
                    testId={"selectDEMOHeaderCountry"}
                />
            )}
        </>
    );
};

export default Countries;